import React from 'react';
import { TDeviceType } from '@cian/ui-kit/types';
import cn from 'clsx';

import { Image, UIHeading5, UIHeading4, UIText2 } from '@cian/ui-kit';

import styles from './styles.css';

export type CardProps = {
  deviceType: TDeviceType;
  title: string;
  text: string;
  imgPath: string;
};

export const Card: React.FC<CardProps> = ({ title, text, imgPath, deviceType }) => {
  const UITitle = deviceType === 'desktop' ? UIHeading5 : UIHeading4;

  return (
    <div className={cn(styles['card'], styles[deviceType])}>
      <div className={styles['text']}>
        <UITitle>{title}</UITitle>
        <UIText2>{text}</UIText2>
      </div>
      <div className={cn(styles['image'], styles[deviceType])}>
        <Image src={`https://static.cdn-cian.ru/frontend/mortgage-assets/${imgPath}`} alt={title} />
      </div>
    </div>
  );
};
